// 4 MiB becomes about 5.34 MiB in base64, leaving room for the Lambda event.
export const MAX_INVOICE_FILE_BYTES = 4 * 1024 * 1024
export const INVOICE_FILE_SIZE_MESSAGE =
  'This invoice file is too large. Please select a JPG, PNG, or PDF no larger than 4 MB per file.'

export async function uploadInvoicesIndividually(body, post) {
  const invoices = []
  const errors = []
  // Sequential requests also keep the server's monthly quota updates in order.
  for (const image of body.images) {
    try {
      const response = await post({ ...body, images: [image] })
      if (!response?.success || !response.newInvoices?.[0]?._id) {
        throw new Error(
          response?.message || 'Upload did not return an invoice id',
        )
      }
      invoices.push(response.newInvoices[0])
      errors.push(null)
    } catch (error) {
      invoices.push(null)
      errors.push(
        error?.response?.status === 413
          ? INVOICE_FILE_SIZE_MESSAGE
          : error?.response?.data?.message || error?.message || 'Upload failed',
      )
    }
  }
  return { invoices, errors }
}
